/* Marijke Amado x skinmade — Cart-Slider auf Basis der Shopify AJAX-Cart.
   Setzt beim ersten Add das Cart-Attribut consultant_id=235 (Neukunde -> Marijke 40%).
   Nur der Checkout ist der geteilte Standard-Shopify-Checkout. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CONSULTANT = (window.MA && window.MA.consultantId) || '235';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: CURRENCY });
  var FREE_SHIP = (window.MA && window.MA.freeShip) || 5000; // 50 € in Cent
  var discountCode = null;

  function updateFreeShip(sub) {
    var fs = document.getElementById('freeship'), txt = document.getElementById('fsText'), fill = document.getElementById('fsFill');
    if (!fs) return;
    var pct = Math.min(100, sub / FREE_SHIP * 100);
    fill.style.transform = 'scaleX(' + (pct / 100) + ')';
    if (sub >= FREE_SHIP) {
      fs.classList.add('fs-done');
      txt.innerHTML = '<b>Geschafft.</b> Du erhältst kostenlosen Versand.';
    } else {
      fs.classList.remove('fs-done');
      txt.innerHTML = 'Noch <b>' + fmt.format((FREE_SHIP - sub) / 100) + '</b> bis zum kostenlosen Versand.';
    }
  }

  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var itemsBox = document.getElementById('cartItems');
  var totalEl = document.getElementById('cartTotal');
  var countEl = document.getElementById('cartCount');

  function openCart() { drawer.classList.add('open'); scrim.classList.add('open'); }
  function closeCart() { drawer.classList.remove('open'); scrim.classList.remove('open'); }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function setConsultant() {
    var attrs = {}; attrs['consultant_id'] = CONSULTANT;
    return post('cart/update.js', { attributes: attrs });
  }

  function render(cart) {
    var count = cart.item_count || 0;
    countEl.textContent = count;
    countEl.style.display = count ? 'flex' : 'none';
    totalEl.textContent = fmt.format((cart.items_subtotal_price || cart.total_price || 0) / 100);
    updateFreeShip(cart.items_subtotal_price || cart.total_price || 0);
    if (!cart.items || !cart.items.length) {
      itemsBox.innerHTML = '<p class="empty">Dein Warenkorb ist leer.<br>Deine Essentials warten.</p>';
      return;
    }
    itemsBox.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
      var sub = (it.properties && it.properties['Kollektion']) ||
        (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : (it.product_type || ''));
      return '<div class="li" data-key="' + it.key + '">' +
        '<div class="thumb">' + img + '</div>' +
        '<div class="info"><div class="n">' + it.product_title + '</div>' +
        '<div class="s">' + sub + '</div>' +
        '<div class="qty"><button data-dec>&minus;</button><span>' + it.quantity + '</span><button data-inc>+</button></div></div>' +
        '<div class="lp">' + fmt.format(it.final_line_price / 100) + '</div></div>';
    }).join('');
  }

  function refresh() { return getCart().then(render); }

  var LINE_PROP = { 'Kollektion': 'Marijke’s Signature Routine' };
  function addVariants(ids) {
    var items = ids.map(function (id) { return { id: Number(id), quantity: 1, properties: LINE_PROP }; });
    return post('cart/add.js', { items: items })
      .then(function () { return setConsultant(); })
      .then(refresh)
      .then(openCart)
      .catch(function () { alert('Das Produkt konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.'); });
  }

  function changeKey(key, qty) {
    return post('cart/change.js', { id: key, quantity: qty }).then(render);
  }

  // Delegated clicks
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addVariants([add.getAttribute('data-variant')]); return; }
    var set = e.target.closest('[data-set]');
    if (set) { e.preventDefault(); addVariants(set.getAttribute('data-variants').split(',')); return; }
    var inc = e.target.closest('[data-inc]');
    if (inc) { var liI = inc.closest('.li'); var q = parseInt(liI.querySelector('.qty span').textContent, 10) + 1; changeKey(liI.dataset.key, q); return; }
    var dec = e.target.closest('[data-dec]');
    if (dec) { var liD = dec.closest('.li'); var q2 = parseInt(liD.querySelector('.qty span').textContent, 10) - 1; changeKey(liD.dataset.key, Math.max(0, q2)); return; }
  });

  var openBtn = document.getElementById('cartOpen');
  var closeBtn = document.getElementById('cartClose');
  if (openBtn) openBtn.addEventListener('click', function () { openCart(); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // Rabattcode
  var dInput = document.getElementById('discountInput');
  var dApply = document.getElementById('discountApply');
  var dChip = document.getElementById('discChip');
  function applyDiscount() {
    var code = (dInput.value || '').trim().toUpperCase();
    if (!code) return;
    discountCode = code;
    dInput.value = '';
    dChip.hidden = false;
    dChip.innerHTML = 'Code <strong>' + code + '</strong> an der Kasse <button type="button" id="discRemove" aria-label="Code entfernen">&times;</button>';
    document.getElementById('discRemove').addEventListener('click', function () {
      discountCode = null; dChip.hidden = true; dChip.innerHTML = '';
    });
  }
  if (dApply) dApply.addEventListener('click', applyDiscount);
  if (dInput) dInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); } });

  // Checkout: nur der "Zur Kasse"-Button wird abgefangen (Express-Buttons bleiben nativ)
  var cartForm = document.getElementById('cartForm');
  if (cartForm) cartForm.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (submitter && submitter.id && submitter.id !== 'checkout') return; // Express/Dynamic-Checkout nativ lassen
    e.preventDefault();
    getCart().then(function (c) {
      if (!c.item_count) { alert('Dein Warenkorb ist noch leer.'); return; }
      setConsultant().then(function () {
        if (discountCode) {
          window.location.href = root + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(root + 'checkout');
        } else {
          window.location.href = root + 'checkout';
        }
      });
    });
  });

  // Club-Formular -> marijke-club-worker (Shopify-Kunde + Tag + Klaviyo "Marijke Club")
  var CLUB_ENDPOINT = 'https://marijke-club-worker.marcel-808.workers.dev/subscribe';
  var club = document.getElementById('clubForm');
  if (club) club.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(club);
    var consentEl = club.querySelector('[name="consent"]');
    var payload = { name: fd.get('name') || '', email: fd.get('email') || '', consent: consentEl ? consentEl.checked : true };
    var btn = club.querySelector('button[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet…'; }
    fetch(CLUB_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.ok) { club.reset(); alert('Danke! Du bist für den Marijke Club vorgemerkt.'); }
        else if (res.error === 'consent_required') { alert('Bitte stimme der Anmeldung zu, um dabei zu sein.'); }
        else { alert('Bitte gib eine gültige E-Mail-Adresse an.'); }
      })
      .catch(function () { alert('Es ist etwas schiefgelaufen. Bitte versuche es später erneut.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
  });

  // Burger / Mobile-Menü
  var burger = document.getElementById('burger');
  var mmenu = document.getElementById('mobileMenu');
  if (burger && mmenu) {
    burger.addEventListener('click', function () {
      var open = mmenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mmenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mmenu.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Init
  refresh();
})();
